import React from 'react';
import { UpDownArrow } from './IconButtons';

const SortingTable = ({sortConfig, tHead}) => {
    return (
        ( sortConfig.key === tHead && sortConfig.direction === "asc" ? 
        <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> : 
        sortConfig.key === tHead && sortConfig.direction === "desc" ? 
        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />)
    )
}

export default SortingTable;
